export default "__VITE_ASSET__NcjtmMUX__"